const textEN = {
  home: "home",
  
};

export default textEN;
